import { InjectionToken } from '@angular/core';

export const CBS_INPUT_VALUE_ACCESSOR = new InjectionToken<{ value: any }>('CBS_INPUT_VALUE_ACCESSOR');
